import { formatDate } from '@angular/common';
import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_9201 implements Validator {

    public static id = 'CTRL_9201';
    private message = 'error.ctr_9201';


    public LOG: LogService = new LogService(CTRL_9201);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_9201.id + '_');
        const ctrlMap = this.formExtractorService.getMap_ControlsID_ControlsIDWithoutStepIdCommonId(form);

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChampNameWithStepId = ctrlMap.get(ctrl.value.rgCtrls.firstChamp);
                const firstChampCtrl = form.controls[firstChampNameWithStepId];
                if (firstChampCtrl.value !== 'yyyy-MM-dd' && firstChampCtrl.value !=="") {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}
